import styles from './HotpleAlbumItems.module.css';


const HotpleAlbumItems = ({mapHotples, activeMenu, setSelectedHotple, hotThreshold, mobileHotpleRefs}) => {
	const whenHotpleClicked = (hotple) =>{
		setSelectedHotple(null);
		setTimeout(() => {
			setSelectedHotple(hotple);
		}, 50);
	};

	const HotpleImage = ({ hotple, mobileHotpleRefs}) => (
		<div className={styles.square} ref={el => mobileHotpleRefs.current[hotple.hotple_id] = el} onClick={()=>whenHotpleClicked(hotple)}>
			<img className={styles.imageIcon} alt="" src={hotple.preview_url}
				loading="lazy" decoding="async"/>
			<div className={styles.tags}>
				<div className={styles.tagplaceDetail}>
					<div className={styles.orange}>{hotple.main_category}</div>
				</div>
				<div className={styles.tagplaceDetail1}>
					<div className={styles.orange}>{hotple.sub_category1} ▸ {hotple.sub_category2}</div>
				</div>
			</div>
			<div className={styles.name}>{hotple.caption}</div>
			<div className={styles.usernameFrame}>
				<img className={styles.iconinstagramColor} src='images/instagram.svg'/>
				<div className={styles.username}>{hotple.media_creator}</div>
				<img className={styles.iconfire2} src='images/like_outlined.svg'/>
				<div className={styles.username2}>{hotple.mention_count}</div>
			</div>
		</div>
	);

  	return (
		<div className={styles.content}>
			{mapHotples.hotples.map((hotple) => (
			<HotpleImage
				key={hotple.hotple_id}
				hotple={hotple}
				mobileHotpleRefs={mobileHotpleRefs}
			/>
			))}
		</div>
	);
};

export default HotpleAlbumItems;
